import {IOnDestroy, IOnInit, IRootElementService} from "angular";
import {ReplaySubject} from "rxjs";
import {SystemEventService} from "../../../services/system-state/SystemEventService";
import {SystemEvent} from "../../../services/system-state/SystemEvent";
import {Optional} from "../../../js/util/Optional";

export abstract class NVD3ChartController implements IOnInit, IOnDestroy {

    protected api: NVD3ChartApi | null;

    protected readonly destroyed$ = new ReplaySubject<boolean>(1);

    protected constructor(protected readonly systemEventService: SystemEventService) {

    }

    public $onInit(): void {
        this.systemEventService
            .takeUntil(this.destroyed$)
            .subscribe(this.onSystemEvent.bind(this));
    }

    private onSystemEvent(event: SystemEvent) {
        if (event === SystemEvent.WINDOW_BLUR) {
            this.hideTooltip();
        } else if (event === SystemEvent.VIEW_RESIZE) {
            Optional.of(this.api)
                    .ifPresent(api => api.refresh());
        }
    }

    private hideTooltip() {
        this.findCurrentTooltip()
            .ifPresent(tt => tt.hidden(true));
    }

    // angular-nv doesn't clean up after itself properly, so we have to make sure the old tooltip is gone
    private ensureTooltipRemoved() {
        this.findCurrentTooltip()
            .map(tooltip => tooltip.id())
            .map(id => document.querySelector(`#${id}`))
            .ifPresent(el => el.remove());
    }

    private findCurrentTooltip() {
        return Optional.of(this.api)
                       .map(api => api.getScope())
                       .map(scope => scope.chart)
                       .map(chart => chart.interactiveLayer)
                       .map(layer => layer.tooltip);
    }

    protected get chart(): Optional<NVD3Chart> {
        return Optional.of(this.api)
                       .map((api) => api.getScope())
                       .map((scope) => scope.chart);
    }

    protected get chartApi(): Optional<NVD3ChartApi> {
        return Optional.of(this.api);
    }

    public chartReady($scope: any, $elem: IRootElementService) {
        this.api = $scope.api;
    }

    public $onDestroy(): void {
        this.ensureTooltipRemoved();
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
